<template>
  <div class="repository-warp">
    <div class="repository-content">
      <div class="search-warp">
        <el-select v-model="search.status" size="small" style="width:160px;" filterable placeholder="计划状态">
          <el-option label="全部状态" :value="-1"></el-option>
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-date-picker v-model="search.time" style="width:160px;margin-left:14px" size="small" type="month" value-format="yyyy/MM/dd">
        </el-date-picker>
        <el-button type="primary" size="small" style="margin-left:14px" @click="getData(1)">查询</el-button>
      </div>
      <div class="table-warp">
        <nk-table :columns="columns" :data="tableData" :page="page" :showPage="true" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
          <el-table-column slot="status" label="状态" width="100">
            <template slot-scope="scope">
              {{getStatus(scope.row.status)}}
            </template>
          </el-table-column>
          <el-table-column slot="type" label="类型" width="100">
            <template slot-scope="scope">
              {{getType(scope.row.type)}}
            </template>
          </el-table-column>
          <el-table-column slot="time" label="计划起止时间" width="260">
            <template slot-scope="scope">
              {{$moment(scope.row.startTime).format('YYYY/MM/DD')}}~{{$moment(scope.row.endTime).format('YYYY/MM/DD')}}
            </template>
          </el-table-column>
          <el-table-column label="操作" :align="'center'" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="showInfo( scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>
    </div>

    <el-drawer title="详情" :visible.sync="drawer" direction="rtl">
      <div class="drawer-main" v-if="info">
        <div class="drawer-cent">
          <div class="title">计划信息</div>
          <div>
            <div class="detailbox">
              <span class="label">计划名称</span><span>{{ info.name }}</span>
            </div>
            <div class="detailbox">
              <span class="label">计划状态</span><span>{{getStatus(info.status) }}</span>
            </div>
            <div class="detailbox">
              <span class="label">计划类型</span><span>{{getTask(info.type) }}</span>
            </div>
            <div class="detailbox">
              <span class="label">开始时间</span><span>{{ info.startTime }}</span>
            </div>
            <div class="detailbox">
              <span class="label">结束时间</span><span>{{ info.endTime }}</span>
            </div>
            <div class="detailbox">
              <span class="label">创建时间</span><span>{{ info.creatingTime }}</span>
            </div>
            <div class="detailbox">
              <span class="label">创建人</span><span>{{ info.creatorNickname }}</span>
            </div>
          </div>
          <div class="title">项目信息</div>
          <div>
            <div class="detailbox">
              <span class="label">项目名称</span><span>{{ info.projectInfoVO.projectName }}</span>
            </div>
            <div class="detailbox">
              <span class="label">项目编号</span><span>{{ info.projectInfoVO.projectNumber }}</span>
            </div>
            <div class="detailbox">
              <span class="label">项目备注</span><span>{{ info.projectInfoVO.projectRemark }}</span>
            </div>
          </div>
          <div class="title" style="margin-top:10px">服务内容</div>
          <div>
            <div class="detailbox">
              <span class="label">区域</span><span>{{ info.projectInfoVO.regionName }}</span>
            </div>
            <div class="detailbox">
              <span class="label">备注</span><span>{{ info.projectInfoVO.regionRemark }}</span>
            </div>
            <div class="detailbox">
              <div class="label">设备列表</div>
              <div>
                <p v-for="(item,index) in info.projectInfoVO.scopes" :key="index">{{ item.measureName }}</p>
              </div>
            </div>

          </div>
          <div class="title" style="margin-top:10px">规格内容</div>
          <div>
            <div class="detailbox">
              <span class="label">类型</span><span>{{getTask(info.projectInfoVO.specificationType) }}</span>
            </div>
            <template v-if="info.specificationConfig">
              <div class="detailbox">
                <span class="label">周期</span><span>{{ getCycle(info.projectInfoVO.specificationConfig.cycle) }}</span>
              </div>
              <div class="detailbox">
                <span class="label">次数</span><span>{{ info.projectInfoVO.specificationConfig.times }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import NkTable from '@/components/common/NkTable.vue'
import api from '../../../../../common/api'
import dateTool from '@/utils/dateTool'
export default {
  components: { NkTable },
  data () {
    return {
      companyId: 0,
      search: {
        status: -1,
        time: null
      },
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      statusList: [
        { label: '计划中', value: 1 },
        { label: '已过期', value: 2 },
        { label: '已取消', value: 3 },
        { label: '执行中', value: 4 },
        { label: '已完成', value: 5 }
      ],
      taskList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 }
      ],
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      columns: [
        { prop: 'name', label: '计划名称', width: 200 },
        { prop: 'clientCompanyName', label: '客户', width: 160 },
        { slot: 'type', label: '类型', width: 80 },
        { slot: 'status', label: '状态', width: 80 },
        { prop: 'creatorNickname', label: '创建人', width: 80 },
        { slot: 'time', label: '计划起止时间', width: 160 },
        { prop: 'describe', label: '描述' },
      ],
      tableData: [],
      page: {
        pageSizes: [10, 20, 30, 40], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      drawer: false,
      info: null
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    getData (pageIndex) {
      let vm = this
      const companyId = vm.companyId
      const { size } = vm.page
      const { status } = vm.search
      let startTime = null
      let endTime = null
      if (vm.search.time) {
        let date = new Date(vm.search.time)
        startTime = dateTool.format(date, "yyyy/MM") + "/01 00:00:00"
        date.setMonth(date.getMonth() + 1)
        endTime = dateTool.format(date, "yyyy/MM") + "/01 00:00:00"
      }
      api.electricOperations.listWorkOrderPlanInfoInPage(companyId, pageIndex, endTime, size, startTime, status).then(res => {
        let tableData = []
        if (res.success) {
          tableData = res.data.listData
          vm.page.pageIndex = res.data.currentPage
          vm.page.size = res.data.pageSize
          vm.page.total = res.data.totalCount
        }
        vm.tableData = tableData
      })
    },
    handleSizeChange (val) {
      this.size = val
      this.getData(1)
    },
    handleCurrentChange (val) {
      this.getData(val)
    },
    showInfo (row) {
      let vm = this
      let info = row
      if (info.projectInfoVO && info.projectInfoVO.specificationConfig.length > 0) {
        info.projectInfoVO.specificationConfig = JSON.parse(info.projectInfoVO.specificationConfig)
      }
      vm.info = info
      vm.drawer = true
    },
    getType (cellValue) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    getStatus (cellValue) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    getTask (cellValue) {
      let val = ''
      this.taskList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    getCycle (cellValue) {
      let val = ''
      this.cycleList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
  }
}
</script>

<style lang="scss" scoped>
.repository-warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  text-align: left;
  box-sizing: border-box;
  .repository-content {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    text-align: left;

    .search-warp {
      padding-bottom: 14px;
    }
    .table-warp {
      flex: 1;
      overflow: hidden;
    }
    .form-container {
      padding: 0px 14px;
    }
  }
}

.drawer-main {
  color: #333;
  padding: 20px 30px 30px 30px;
  .drawer-header {
    display: flex;
    margin-bottom: 40px;
    .headbox {
      color: #999999;
      margin-right: 10px;
      .title {
        margin-right: 10px;
      }
      .satus {
        display: inline-block;
        padding: 8px;
        background: #f7eee9;
        border-radius: 4px;
        color: #fda32b;
      }
      .month {
        font-size: 24px;
        color: #333;
      }
    }
  }
  .drawer-cent {
    div {
      text-align: left;
    }
    .title {
      font-size: 18px;
    }
    .detailbox {
      margin-top: 15px;
      display: flex;
      .label {
        color: #999999;
        display: inline-block;
        width: 100px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }
}
</style>
<style lang="scss">
.rows-content {
  .el-textarea__inner {
    min-height: 240px !important;
  }
}
</style>